module.exports = __webpack_public_path__ + "img/img_sec5_03.0279ec90.jpg";